import React, { type InputHTMLAttributes } from 'react';
import { Check, X } from 'lucide-react';

interface TextInputProps extends InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement> {
  label?: string;
  isTextArea?: boolean;
  state?: 'idle' | 'valid' | 'invalid';
  hint?: string;
  rows?: number;
}

export const TextInput: React.FC<TextInputProps> = ({
  id,
  label,
  isTextArea,
  state = 'idle',
  hint,
  maxLength,
  value,
  className = '',
  ...props
}) => {
  const valString = String(value ?? '');
  
  return (
    <div className={`input-group ${state !== 'idle' ? `input-${state}` : ''} ${className}`}>
      {label && <label htmlFor={id}>{label}</label>}
      {isTextArea ? (
        <textarea
          id={id}
          value={value}
          maxLength={maxLength}
          aria-invalid={state === 'invalid'}
          aria-describedby={state === 'invalid' ? `${id}-error` : undefined}
          {...(props)}
        />
      ) : (
        <input
          id={id}
          value={value}
          maxLength={maxLength}
          aria-invalid={state === 'invalid'}
          aria-describedby={state === 'invalid' ? `${id}-error` : undefined}
          {...(props)}
        />
      )}
      {(state !== 'idle' || maxLength != null || hint != null) && (
        <div className="input-footer">
          <div className="flex-row-center-gap-4">
            {state === 'valid' && <span className="field-status valid"><Check size={14} /></span>}
            {state === 'invalid' && <span className="field-status invalid"><X size={14} /></span>}
            {hint && <span className="hint hint-text">{hint}</span>}
          </div>
          {maxLength && (
            <span className={`char-counter ${valString.length >= maxLength ? 'limit-reached' : ''}`}>
              {valString.length} / {maxLength}
            </span>
          )}
        </div>
      )}
    </div>
  );
};
